import React, { useEffect } from "react";
import PrismicRichText from "../components/PrismicRichText";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import styled from "styled-components";
import { get } from "lodash";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const StlWrapper = styled.div`
  display: grid;
  grid-gap: 25px;
  color: #e0fc01;
  h2 {
    margin-right: auto;
  }
  p,
  ul li {
    color: white;
    font-size: 20px;
    padding-bottom: 20px;
  }
  li {
    padding-bottom: 10px !important;
  }
  a,
  span {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
    .icon {
      font-size: 2.5rem;
    }
    p,
    ul li {
      font-size: 25px;
    }
  }
`;

const StlCopy = styled.div`
  color: #e0fc01;
  margin-bottom: 40px;
  h2 {
    font-size: 50px;
    line-height: 1;
    @media (min-width: 1100px) {
      font-size: 80px;
      padding: 30px 0;
    }
  }
`;

const StlFAQItem = styled.div`
  border-bottom: 1px solid #e0fc01;
  .onClick {
    text-decoration: underline;
  }

  img {
    max-width: 100%;
  }
`;

const Row = ({ row }) => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const labResultsPage = location.pathname === "/lab-test-results";
  const dispatch = useDispatch();

  const openDialog = () => {
    dispatch({
      type: "DIALOG/SHOW",
      id: "d9_hemp_dialog",
    });
  };
  useEffect(() => {
    if (!labResultsPage) return;
    const elements = document.querySelectorAll(".onClick");
    elements.forEach((el) => {
      el.addEventListener("click", openDialog);
    });
    return () => {
      elements.forEach((el) => {
        el.removeEventListener("click", openDialog);
      });
    };
  }, [labResultsPage, openDialog]);

  return (
    <StlFAQItem className="faq-item border rounded p-4">
      <div
        onClick={() => setOpen(!open)}
        className="question flex justify-between items-center cursor-pointer averta-bold"
      >
        <PrismicRichText render={row?.question} />
        {open ? (
          <KeyboardArrowUpIcon
            onClick={() => setOpen(!open)}
            className="icon"
          />
        ) : (
          <KeyboardArrowDownIcon
            onClick={() => setOpen(!open)}
            className="icon"
          />
        )}
      </div>
      {open && (
        <div className="answer mt-2">
          <PrismicRichText render={row?.answer} />
        </div>
      )}
    </StlFAQItem>
  );
};

export default function RenderFAQSection(slice) {
  const content = get(slice, "primary.content");
  const renderFAQs = (items) => {
    return items.map((el, i) => <Row key={i} row={el} />);
  };
  return (
    <section className="faq-section standard-padding">
      {content && (
        <StlCopy>
          <PrismicRichText render={content} />
        </StlCopy>
      )}
      <StlWrapper>{renderFAQs(slice?.items)}</StlWrapper>
    </section>
  );
}
